__turbopack_context__.v({
  "divider": "header-module-scss-module__F4vtIq__divider",
  "fadeOverlay": "header-module-scss-module__F4vtIq__fadeOverlay",
  "fullMenu": "header-module-scss-module__F4vtIq__fullMenu",
  "header": "header-module-scss-module__F4vtIq__header",
  "headerBar": "header-module-scss-module__F4vtIq__headerBar",
  "logo": "header-module-scss-module__F4vtIq__logo",
  "mainMenu": "header-module-scss-module__F4vtIq__mainMenu",
  "menuIcon": "header-module-scss-module__F4vtIq__menuIcon",
  "menuItemLarge": "header-module-scss-module__F4vtIq__menuItemLarge",
  "observer": "header-module-scss-module__F4vtIq__observer",
  "overlay": "header-module-scss-module__F4vtIq__overlay",
  "search": "header-module-scss-module__F4vtIq__search",
  "searchIcon": "header-module-scss-module__F4vtIq__searchIcon",
  "siteMenu": "header-module-scss-module__F4vtIq__siteMenu",
  "slideDown": "header-module-scss-module__F4vtIq__slideDown",
  "slideInFromRight": "header-module-scss-module__F4vtIq__slideInFromRight",
  "slideOutRight": "header-module-scss-module__F4vtIq__slideOutRight",
  "slideUp": "header-module-scss-module__F4vtIq__slideUp",
  "toggleMenu": "header-module-scss-module__F4vtIq__toggleMenu",
});
